export default "__VITE_ASSET__a33abe2b__"